import { StyleSheet } from 'react-native';
import { grid } from '@shared/styles';

export const styles = StyleSheet.create({
  input: {
    paddingVertical: grid(1),
    paddingHorizontal: grid(2),
    borderRadius: grid(1),
    width: grid(20),
    marginHorizontal: grid(1),
  },
});
